import { render, staticRenderFns } from "./cptList.vue?vue&type=template&id=10bfd8f2&"
import script from "./cptList.vue?vue&type=script&lang=js&"
export * from "./cptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports